import { css } from 'lit';
export const selectStyles = css `
    .hlx-select-popup-container {
        position: absolute;
        border-radius: var(--hlx-radius-xs);
        background: var(--hlx-background-color-default);
        padding: var(--hlx-spacing-md);
        border: 1px solid var(--hlx-border-color-default);
        max-height: calc(2 * var(--hlx-spacing-md) + 226px);
        z-index: 1070;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: var(--hlx-spacing-2xs);
    }

    .hlx-select-popup-container:not([open]) {
        visibility: hidden;
        opacity: 0;
    }

    .hlx-select-popup-container[open] {
        visibility: visible;
        opacity: 1;
    }

    .hlx-select-icon-container {
        height: 100%;
        color: var(--hlx-button-color-tertiary-brand-default);
        padding: 0 var(--hlx-spacing-md) 0 var(--hlx-spacing-md);
        display: flex;
        align-items: center;
    }

    .hlx-select-text-field {
        cursor: pointer;
        overflow: visible;
        position: relative;
    }

    .hlx-select-text-field-control {
        line-height: var(--hlx-text-line-height-tight-1);
        background: none;
        display: flex;
        align-items: center;
        min-width: 0;
    }

    .hlx-select-placeholder {
        color: var(--hlx-input-placeholder-text-color-default);
        font-weight: var(--hlx-text-font-weight-normal);
        user-select: none;
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;
//# sourceMappingURL=select.styles.js.map